/**
 * Given a list of functions that take no arguments and return void, this function
 * returns a single function that invokes all of the functions in the list.
 *
 * That is all it does.
 *
 * This is useful in the UI when you have a handful of effects that take no arguments
 * and are otherwise very simple, but need to be triggered at once.
 *
 * @example
 * const fn1 = () => console.log("fn1");
 * const fn2 = () => console.log("fn2");
 * const composed = composeSimpleFunctions(fn1, fn2);
 * composed(); // logs "fn1" and then "fn2"
 */
export function composeSimpleFunctions(
  ...fns: (undefined | (() => void))[]
): () => void {
  return () => fns.forEach((fn) => fn?.());
}
